import React, { useEffect, useState } from 'react';
import { Table, TableSearch, TableColumnOpcoes, Icon } from '@components';
import { getVariaveisAmbiente } from '@ducks/indicadoresVariaveisAmbiente';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

export default function TableVariaveisAmbiente({ idCliente }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const variaveisAmbiente = useSelector(({ indicadoresVariaveisAmbiente }) =>
    indicadoresVariaveisAmbiente.get('variaveisAmbiente').toArray()
  );
  const loadingVariaveisAmbiente = useSelector(({ indicadoresVariaveisAmbiente }) =>
    indicadoresVariaveisAmbiente.get('loadingVariaveisAmbiente')
  );

  const handleSearch = () => {
    return dispatch(getVariaveisAmbiente(idCliente));
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Variável',
      dataIndex: 'variavel',
      key: 'variavel',
      ...TableSearch('variavel', 'variável', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Descrição',
      dataIndex: 'ds',
      key: 'ds',
      ...TableSearch('ds', 'descrição', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Valores',
      dataIndex: 'valores',
      key: 'valores',
      ...TableSearch('valores', 'valor', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Opções',
      dataIndex: 'idInformacao',
      key: 'options',
      align: 'right',
      width: '20%',
      render: (text, item) => (
        <TableColumnOpcoes>
          <Icon.Edit
            tooltipTitle="Editar variável de ambiente"
            action={() => history.push(`/indicadores/variaveis/ambiente/${idCliente}/${item.idInformacao}`)}
          />
          <Icon.Edit customIcon={Icon.SettingOutlined} tooltipTitle="Configurar variável de ambiente" />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey="id" columns={columns} dataSource={variaveisAmbiente} loading={loadingVariaveisAmbiente} hidePagination />;
}
